export const lifecycleStatuses = [
    { value: 'active', label: 'Active' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'expired', label: 'Expired' },
    { value: 'archived', label: 'Archived' }
];

export const normalizeDateTimeInput = (value) => {
    if (!value) {
        return '';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    const pad = (part) => String(part).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const isoFromDateTimeInput = (value) => {
    if (!value) {
        return undefined;
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};

export const getLifecycleStatus = (product = {}) => {
    if (product.status === 'archived' || product.archivedAt) {
        return 'archived';
    }

    const configuredStatus = product.status || 'active';
    const now = Date.now();
    const startsAt = product.startsAt ? new Date(product.startsAt).getTime() : null;
    const expiresAt = product.expiresAt ? new Date(product.expiresAt).getTime() : null;

    if (Number.isFinite(expiresAt) && expiresAt < now) {
        return 'expired';
    }
    if (Number.isFinite(startsAt) && startsAt > now) {
        return 'scheduled';
    }

    return configuredStatus === 'scheduled' ? 'active' : configuredStatus;
};

export const lifecycleChipColor = (status) => ({
    active: 'success',
    scheduled: 'info',
    expired: 'warning',
    archived: 'default'
}[status] || 'default');

export const getLifecycleErrors = (values = {}) => {
    const errors = [];

    if (values.startsAt && Number.isNaN(new Date(values.startsAt).getTime())) {
        errors.push('Start date/time must be valid.');
    }
    if (values.expiresAt && Number.isNaN(new Date(values.expiresAt).getTime())) {
        errors.push('Expiry date/time must be valid.');
    }
    if (
        values.startsAt
        && values.expiresAt
        && new Date(values.expiresAt).getTime() < new Date(values.startsAt).getTime()
    ) {
        errors.push('Expiry date/time cannot be before start date/time.');
    }

    return errors;
};
